import { Component, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'; // Import BreakpointObserver and Breakpoints
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from '../../../material.module';
import { tenantSettings, ThemeService } from 'src/theme';
import { CustomersService } from '@lib/services/customer/customer.service';
import { SidePanelService } from '@lib/services';
import { BaseComponent } from '@lib/components/base';
import { MenuItem } from '@lib/interfaces';

@Component({
    standalone: true,
    imports: [CommonModule, RouterModule, AngularMaterialModule],
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent extends BaseComponent {
    @Output() collapseStatusChange: EventEmitter<{ isCollapseNav: boolean; isMobile: boolean }> = new EventEmitter<{ isCollapseNav: boolean; isMobile: boolean }>();
    isCollapseNav = false;
    panelOpenState = false;
    menuItems: any;
    lowerMenuItems: any;
    isMobile = false;
    logo: string;
    isSubAgent = localStorage.getItem('isSubAgent');
    protected isRiyadTenant: boolean;
    // NEOIQ-2427: gates "Find Super Agent"/"Top up for Agent"-style menu items. custom_info isn't
    // cached in localStorage (see neo-home.component.ts), so it needs its own fetch here too.
    protected isSuperAgent = false;

    constructor(private eRef: ElementRef, private breakpointObserver: BreakpointObserver, private readonly themeService: ThemeService, private readonly customersService: CustomersService, private readonly sidePanel: SidePanelService) {
        super();
        this.getLogo();
        const tenantKey = localStorage.getItem('tenantKey') || '';
        const riyadTenant = tenantSettings.find((tenant) => tenant.name.toLowerCase() === 'riyad');
        this.isRiyadTenant = tenantKey === riyadTenant?.key;

        this.breakpointObserver.observe(['(max-width: 767px)']).subscribe((result) => {
            this.isMobile = result.matches;
            if (this.isMobile) {
                this.collapseNav();
            } else {
                this.unCollapseNav();
            }
        });

        this.menuItems = themeService.getActiveThemeAssets('sideMenu');
        this.lowerMenuItems = themeService.getActiveThemeAssets('sideMenuSecondaryItems');
        this.fetchIsSuperAgent();
    }

    private fetchIsSuperAgent(): void {
        const userId = localStorage.getItem('userId');
        if (!userId) return;

        this.addSubscription(
            this.customersService.fetchCustomerDetailsById(userId).subscribe({
                next: (customer) => {
                    this.isSuperAgent = customer.custom_info?.['is_super_agent'] === 'true';
                },
                error: () => {
                    this.isSuperAgent = false;
                },
            }),
        );
    }

    // NEOIQ-2427: items with `panelId` open as a SidePanelService dialog instead of routing.
    // Dynamically imported so the component (and its deps, e.g. Google Maps for
    // "find-super-agent") aren't pulled into the side-nav's own bundle for tenants that never use it.
    protected openPanelItem(item: MenuItem): void {
        switch (item.panelId) {
            case 'find-super-agent':
                import('@pages/find-super-agent/find-super-agent.component').then(({ FindSuperAgentComponent }) => {
                    this.sidePanel.open(FindSuperAgentComponent);
                });
                break;
        }
    }

    private getLogo() {
        this.logo = this.themeService.getActiveThemeAssets('logoSvg');
    }

    collapseNav() {
        this.isCollapseNav = true;
        this.collapseStatusChange.emit({ isCollapseNav: this.isCollapseNav, isMobile: this.isMobile });
    }

    unCollapseNav() {
        this.isCollapseNav = false;
        this.collapseStatusChange.emit({ isCollapseNav: this.isCollapseNav, isMobile: this.isMobile });
    }

    toggleCollapseNav() {
        // if (this.isMobile) return;
        this.isCollapseNav = !this.isCollapseNav;
        this.collapseStatusChange.emit({ isCollapseNav: this.isCollapseNav, isMobile: this.isMobile });
    }
    onMenuItemClick(): void {
        if (!this.isMobile) return;
        this.isCollapseNav = true;
    }
    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        if (!this.isMobile) return;
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.isCollapseNav = true;
        }
    }
}
